/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { computed } from "mobx";

import { Button } from "arv-reactcomponents";
import { readCookie } from "../../../../utils";
import Analytics from "../../../../analytics";
import Event from "../../../../analytics/eventFactory";

@inject("LoginStore", "MybagStore")
@observer
class Login extends Component {
  static trackLoginClick() {
    Analytics.trackEvent({
      action: Event.action.LOGIN_CLICK,
      label: Event.label.getSource(window.pageType),
      category: Event.category.TOP_ABOVE_MENU_CTR,
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
    this.showLoginModal = this.showLoginModal.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.logout = this.logout.bind(this);
  }

  @computed
  get firstName() {
    const firstName = this.props.LoginStore.account.userInfo
      ? this.props.LoginStore.account.userInfo.firstName
      : null;
    return readCookie("userName") || firstName;
  }

  showLoginModal() {
    this.props.LoginStore.setloginModal(true);
    Login.trackLoginClick();
  }

  handleMouseEnter() {
    this.setState({ isHovered: true });
  }
  handleMouseLeave() {
    this.setState({ isHovered: false });
  }
  logout() {
    this.props.LoginStore.logoutAction();
    this.props.MybagStore.clearCart();
    this.setState({ isHovered: false });
  }

  render() {
    const { className, text } = this.props;
    const userName = this.firstName;
    return (
      <div className={`nw-topbar-login ${className}`}>
        {this.props.LoginStore.isUserLoggedIn ? (
          <div
            className="nw-login-name"
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            <i className="icomoon-person1 nw-lname-ico" />
            <span className="nw-topbar-login-links">
              {userName}&nbsp;
              {this.state.isHovered ? (
                <i className="icomoon-arrow_top nw-lname-ico" />
              ) : (
                <i className="icomoon-arrow_bottom nw-lname-ico" />
              )}
            </span>
            {this.state.isHovered ? (
              <div className="nw-login-hover">
                <ul className="nw-login-hoverlist">
                  <li className="nw-login-accountlist">
                    <a className="nw-topbar-login-links" href="/account">
                      my account
                    </a>
                  </li>
                  <li className="nw-login-accountlist">
                    <a className="nw-topbar-login-links" href="/favorites">
                      my favourites
                    </a>
                  </li>
                  <li className="nw-login-accountlist" onClick={this.logout}>
                    <a
                      className="nw-topbar-login-links"
                      href="javascript:void(0)"
                    >
                      signOut
                    </a>
                  </li>
                </ul>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <Button
            className={`
              nwc-btn-primary-txt
              nw-actionbuttons-btn
              nw-actionbuttons-person
              ${className}
              `}
            onClick={this.showLoginModal}
          >
            <i className="icomoon-person1" />
            <span className="nw-actionbuttons-text">{text}</span>
          </Button>
        )}
      </div>
    );
  }
}

Login.wrappedComponent.defaultProps = {
  className: "",
  text: "",
};

Login.wrappedComponent.propTypes = {
  MybagStore: PropTypes.shape({
    clearCart: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool,
    setloginModal: PropTypes.func.isRequired,
    logoutAction: PropTypes.func.isRequired,
    account: PropTypes.shape({
      userInfo: PropTypes.shape({
        firstName: PropTypes.string,
      }),
    }),
  }).isRequired,
  className: PropTypes.string,
  text: PropTypes.string,
};

export default Login;



// WEBPACK FOOTER //
// ./src/component/Header/ActionButtons/Login/index.js